// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__5_RYJ","actionsCol":"EnrolledClinics_actionsCol__3gGlv"};